import { Option } from '../option';
import { ArrayOps } from '../lift';
/**
 * Returns the first item of this Array, as an Option.
 */
export function first() {
    return Option(this.value()[0]);
}
ArrayOps.prototype.first = first;
